import { Row, Col, Card, Statistic, notification } from 'antd';
import pagination from 'antd/lib/pagination';
import { FC, useEffect, useState } from 'react';
import restful from '../../restful';

type Status = {
    new: number;
    paid: number;
    doing: number;
    done: number;
    error: number;
    awaiting: number;
}
const OrderStatus: FC = () => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [status, setStatus] = useState<Status>({
        new: 0, paid: 0, doing: 0, done: 0, error: 0, awaiting: 0,
    });

    const fetchData = () => {
        setIsLoaded(true);
        restful.get(`/orders/status`)
            .then((res) => {
                setStatus(res.data.result);
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <Row gutter={[16, 16]}>
            <Col md={4}>
                <Card><Statistic title="جدید" loading={isLoaded} value={status.new} /></Card>
            </Col>
            <Col md={4}>
                <Card><Statistic title="پرداخت شده" loading={isLoaded} value={status.paid} /></Card>
            </Col>
            <Col md={4}>
                <Card><Statistic title="در حال انجام" loading={isLoaded} value={status.doing} /></Card>
            </Col>
            <Col md={4}>
                <Card><Statistic title="انجام شده" loading={isLoaded} value={status.done} /></Card>
            </Col>
            <Col md={4}>
                <Card><Statistic title="خطا" loading={isLoaded} value={status.error} /></Card>
            </Col>
            <Col md={4}>
                <Card><Statistic title="انتظار پرداخت" loading={isLoaded} value={status.awaiting} /></Card>
            </Col>
        </Row>
    );
}

export default OrderStatus;
